export default __webpack_public_path__ + "media/images/features/ja/people-4666766b1fd388adb64c262608c85d2d.png";